import React from 'react'

function NotFound() {
  return (
    <div>
      Ruta No Encontrada  
    </div>
  )
}

export default NotFound
